import { api, apiText } from '@/services/api.js';

// Fields the portal is allowed to edit. The AWS Marketplace identifiers
// (customerIdentifier, customerAWSAccountId, productCode) are resolved from the
// subscription token and stay read-only.
const EDITABLE_FIELDS = ['company', 'name', 'forname', 'title', 'email', 'phone'];

export default {
  // Returns the list of customer contact requests captured by the landing page.
  getCustomers() {
    return api('/customers', {
      method: "GET"
    });
  },

  // Updates the editable contact fields of a single request.
  updateCustomer(customer) {
    const payload = {};
    EDITABLE_FIELDS.forEach((field) => {
      // The table renders missing values as "-"; never write that back.
      const value = customer[field];
      payload[field] = value === undefined || value === null || value === '-' ? '' : value;
    });

    return api('/customers/' + encodeURIComponent(customer.id), {
      method: "PUT",
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
  },

  // Downloads every request as CSV text.
  downloadExport() {
    return apiText('/customers/export', {
      method: "GET"
    });
  },

  // Uploads CSV text; rows are upserted on `id`.
  importCustomers(csvText) {
    return api('/customers/import', {
      method: "POST",
      headers: { 'Content-Type': 'text/csv' },
      body: csvText
    });
  }
};
